import { Subject } from "rxjs"
import apiResponse from "../../../../../services/apiResponse"
import DataTableRepository from "../Repositories/DataTableRepository"

class DataTableBloc {
    rowtableChannel = new Subject()
    historyChannel = new Subject()
    inactiveChannel = new Subject()
    activeChannel = new Subject()
    forceChannel = new Subject()
    cancelChannel = new Subject()
    repository = new DataTableRepository()

    constructor() {
        this.rowtableChannel.next({ status: apiResponse.INITIAL })
        this.historyChannel.next({ status: apiResponse.INITIAL })
        this.inactiveChannel.next({ status: apiResponse.INITIAL })
        this.activeChannel.next({ status: apiResponse.INITIAL })
        this.forceChannel.next({ status: apiResponse.INITIAL })
        this.cancelChannel.next({ status: apiResponse.INITIAL })
    }

    fetchRowTable = async (query, cancelToken) => {
        this.rowtableChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository
                .fetchRowTable(query, cancelToken)
                .then((result) => {
                    this.rowtableChannel.next({
                        status: apiResponse.COMPLETED,
                        data: result,
                    })
                })
                .catch((error) => {
                    this.rowtableChannel.next({
                        status: apiResponse.ERROR,
                        data: error,
                    })
                })
        } catch (error) {}
    }

    fetchHistory = async (query) => {
        this.historyChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository
                .fetchHistory(query)
                .then((result) => {
                    this.historyChannel.next({
                        status: apiResponse.COMPLETED,
                        data: result,
                    })
                })
                .catch((error) => {
                    this.historyChannel.next({
                        status: apiResponse.ERROR,
                        data: error,
                    })
                })
        } catch (error) {}
    }

    fetchInactive = async (query) => {
        this.inactiveChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository
                .fetchInactive(query)
                .then((result) => {
                    this.inactiveChannel.next({
                        status: apiResponse.COMPLETED,
                        data: result,
                    })
                })
                .catch((error) => {
                    this.inactiveChannel.next({
                        status: apiResponse.ERROR,
                        data: error,
                    })
                })
        } catch (error) {}
    }

    fetchActive = async (query) => {
        this.activeChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository
                .fetchActive(query)
                .then((result) => {
                    this.activeChannel.next({
                        status: apiResponse.COMPLETED,
                        data: result,
                    })
                })
                .catch((error) => {
                    this.activeChannel.next({
                        status: apiResponse.ERROR,
                        data: error,
                    })
                })
        } catch (error) {}
    }

    fetchForce = async (query) => {
        this.forceChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository
                .fetchForce(query)
                .then((result) => {
                    this.forceChannel.next({
                        status: apiResponse.COMPLETED,
                        data: result,
                    })
                })
                .catch((error) => {
                    this.forceChannel.next({
                        status: apiResponse.ERROR,
                        data: error,
                    })
                })
        } catch (error) {}
    }

    fetchCancel = async (query) => {
        this.cancelChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository
                .fetchCancel(query)
                .then((result) => {
                    this.cancelChannel.next({
                        status: apiResponse.COMPLETED,
                        data: result,
                    })
                })
                .catch((error) => {
                    this.cancelChannel.next({
                        status: apiResponse.ERROR,
                        data: error,
                    })
                })
        } catch (error) {}
    }
}

export default DataTableBloc
